import { render, staticRenderFns } from "./DeclaratieModal.vue?vue&type=template&id=964b041e"
import script from "./DeclaratieModal.vue?vue&type=script&lang=js"
export * from "./DeclaratieModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports